import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Row, Col } from 'antd';
import { stringify } from 'qs';

import ArtistCard from './ArtistCard';
import SheetTitle from '../../../components/SheetTitle';

import c from '../Search.less';

function ArtistBlock({
  q, items, standalone, total,
}) {
  const columns = {
    lg: standalone ? 6 : 12,
    md: standalone ? 8 : 12,
    xs: standalone ? 24 : 24,
  };

  return (
    <div>
      <SheetTitle
        title="Artists"
        rightBlock={
          !standalone && total > 6 ? (
            <Link to={`/search/artists?${stringify({ q })}`}>Show more</Link>
          ) : null
        }
      />
      <Row className={c.artistList}>
        {
          items.map((item) => (
            <Col {...columns} key={item.id}>
              <ArtistCard artist={item} />
            </Col>
          ))
        }
      </Row>
    </div>
  );
}

ArtistBlock.propTypes = {
  items: PropTypes.array,
  total: PropTypes.number,
  q: PropTypes.string.isRequired,
  standalone: PropTypes.bool,
};

ArtistBlock.defaultProps = {
  items: [],
  total: 0,
  standalone: false,
};

export default ArtistBlock;
